const taskfilterSortReducer = (
    state = {},
    action: {
      type: "SET_TASK_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_TASK_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default taskfilterSortReducer;